import {createAction, props} from '@ngrx/store';
import {InitDataType} from '../../../@types';
import {UserAuthData} from '../reducers/auth.reducer';
import {LoginFormData} from '../../../../features/login/@types';
import {V1ApiHttpErrorResponse} from '../../../interceptors/v1-http-error-interceptor.service';

/******************************************
 *********** INIT DATA ACTIONS ************
 ******************************************/

export const CheckAuthToken = createAction('[Auth] Check Auth Token');

export const CheckAuthTokenSuccess = createAction('[Auth] Check Auth Token Success');

export const CheckAuthTokenNull = createAction('[Auth] Check Auth Token Null');

export const InitData = createAction('[Auth] Init Data');

export const InitDataSuccess = createAction(
  '[Auth] Init Data Success',
  props<InitDataType>()
);

export const InitDataError = createAction(
  '[Auth] Init Data Error',
  props<{ error: Error }>()
);

/******************************************
 ************* LOGIN ACTIONS **************
 ******************************************/

export const Login = createAction(
  '[Auth] Login',
  props<{ loginFormData: LoginFormData }>());

export const LoginSuccess = createAction(
  '[Auth] Login Success',
  props<{ userAuthData: UserAuthData; loginFormData: LoginFormData }>()
);

export const LoginError = createAction(
  '[Auth] Login Error',
  props<{ error: V1ApiHttpErrorResponse }>()
);

export const AlertLogout = createAction(
  '[Auth] Alert Logout');

export const Logout = createAction(
  '[Auth] Logout');



